import { cn } from '@/lib/utils'

interface Props {
  lang: 'ru' | 'en'
  className?: string
}

/** Круглые флаги языков интерфейса. Нарисованы SVG, а не эмодзи: эмодзи-флаги
 *  не отображаются в Windows. */
export const LanguageFlag = ({ lang, className }: Props) => (
  <span
    aria-hidden="true"
    className={cn('inline-block size-5 shrink-0 overflow-hidden rounded-full', className)}
  >
    {lang === 'ru' ? (
      <svg
        viewBox="0 0 30 20"
        preserveAspectRatio="xMidYMid slice"
        style={{ width: '100%', height: '100%' }}
      >
        <rect width="30" height="20" fill="#fff" />
        <rect y="6.67" width="30" height="6.67" fill="#0039a6" />
        <rect y="13.33" width="30" height="6.67" fill="#d52b1e" />
      </svg>
    ) : (
      <svg
        viewBox="0 0 30 20"
        preserveAspectRatio="xMidYMid slice"
        style={{ width: '100%', height: '100%' }}
      >
        <rect width="30" height="20" fill="#fff" />
        {[0, 2, 4, 6, 8, 10, 12].map((i) => (
          <rect key={i} y={i * (20 / 13)} width="30" height={20 / 13} fill="#b22234" />
        ))}
        <rect width="13" height={(20 / 13) * 7} fill="#3c3b6e" />
      </svg>
    )}
  </span>
)
